import {ObjectId} from './ObjectId';
import {AnimatronProjects} from './AnimatronProjectsSvc';

export interface Wrapped {
    id: string;
    project?: anm.Project;
    ad?: boolean;
    videoUrl?: string;
    href?: string;
    width: number;
    height: number;
}
interface Banners {
    href: string;
    videoUrls: string[];
}

export class AdSvc {
    private static UpgradeBanners: Banners = {
        href: '/settings/subscription',
        videoUrls: [
            'https://videos.animatron.com/banners/upgrade',
            'https://videos.animatron.com/banners/upgrade_screens'
        ]
    };
    private static SignupBanners: Banners = {
        href: '/signup',
        videoUrls: [
            'https://videos.animatron.com/banners/join_the_magic_banner',
            'https://videos.animatron.com/banners/as_easy_as_that'
        ]
    };

    public results: Array<Wrapped> = [];
    private banners: Banners = AdSvc.chooseBanners();
    private currentIdx = this.banners && _.random(this.banners.videoUrls.length - 1);
    private currentPage = 0;
    private static width: number;

    constructor(private enabled = true,
                private $rootScope: ng.IRootScopeService,
                private ProjectInfoHeight = 124) {
        this.$rootScope.$on('project:remove', (e, pid) =>  this.results = this.results.filter(p => p.id !== pid));
    }

    adify(page: Array<anm.Project>): void {
        const newRes: Array<Wrapped> = page.map(project => ({
            id: project.id,
            project,
            width: AdSvc.getWidth(),
            height: project.computedHeight + this.ProjectInfoHeight
        }));
        this.insertBanner(newRes);
        this.results = _.unique(this.results.concat(newRes), false, item => item.id);
    }

    private getBanner(): string {
        return this.banners && this.banners.videoUrls[this.currentIdx++ % this.banners.videoUrls.length];
    }

    private insertBanner(projects: Array<Wrapped>): void {
        if (!this.enabled || this.currentPage++ % 2 !== 0) return;
        const banner = this.getBanner();
        if (banner) {
            const ad: Wrapped = {
                id: 'ad-' + ObjectId.get(),
                ad: true,
                videoUrl: banner,
                href: this.banners.href,
                width: AdSvc.getWidth(),
                height: (AdSvc.getWidth() / 290 * 242)
            };
            const position = _.random(projects.length - 1);
            projects.splice(position, 0, ad);
        }
    }

    private static getWidth() {
        if (!AdSvc.width) {
            AdSvc.width = options.handHeld ? AdSvc.mobileWidth() : AnimatronProjects.computedWidth;
        }
        return AdSvc.width;
    }

    private static chooseBanners() {
        switch (options.user.subscriptionDetails.studio.displayName.toLowerCase()) {
            case 'guest':
                return AdSvc.SignupBanners;
            case 'free':
            case 'starter':
                return AdSvc.UpgradeBanners;
            default:
                return null;
        }
    }

    private static mobileWidth() {
        const projects = document.querySelector('.projects');
        return projects.offsetWidth || AnimatronProjects.computedWidth;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AdSvc.ts